import UserDetail from '~/domains/account/components/UserDetail/UserDetail';
import { UnstyledButtonLink } from '~/domains/design-system/Button';
import { Routes } from '~/domains/common/constants/routes';
import BalanceWidget from '~/domains/account/components/BalanceWidget/BalanceWidget';
import { SocureKycStatus } from '~/services/users/types';
import dt from '~/testing';

import useStyles from './UserMenu.styles';
import type { UserMenuProps } from './types';

function UserDetailBox({
  user,
  KYCStatus,
  cashBalance,
  credits,
  balance,
  refundableBalance,
  playthroughCash,
  handleOpenWithdrawalModal,
  handleOpenDepositModal,
  isLoading,
  isProtectionLoading,
}: Omit<UserMenuProps, 'onClose'>) {
  const { classes, cx } = useStyles();
  const isKYCverified = KYCStatus === SocureKycStatus.ACCEPT;

  if (!user) return null;

  if (!isKYCverified) {
    return (
      <div className={classes.userDetailContainer}>
        <UserDetail user={user} isCompact />
      </div>
    );
  }

  return (
    <div className={cx(classes.balanceWidgetContainer, { isKYCverified })}>
      <UnstyledButtonLink
        data-test-id={dt.common.components.appShellHeader.userMenu.container}
        className={cx(classes.userDetailContainer, { isKYCverified })}
        href={Routes.account()}
      >
        <UserDetail user={user} isCompact />
      </UnstyledButtonLink>
      <BalanceWidget
        cashBalance={cashBalance}
        withdrawableBalance={balance}
        credits={credits}
        refundableBalance={refundableBalance}
        playthroughCash={playthroughCash}
        onWithdraw={handleOpenWithdrawalModal}
        onDeposit={handleOpenDepositModal}
        isLoadingWalletBalance={isLoading}
        isLoadingWalletAction={isProtectionLoading}
        isCompact
      />
    </div>
  );
}

export default UserDetailBox;
